import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=a5561572&scoped=true&"
import script from "./CambiarPassword.vue?vue&type=script&lang=js&"
export * from "./CambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./CambiarPassword.vue?vue&type=style&index=0&id=a5561572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5561572",
  null
  
)

export default component.exports